import { axiosObject } from "../accessServiceConfig";

export function getAllAdmins(params: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = "/loco/resource/admin-admins/_read";

    let payload: any = {};
    payload["apiConfig"] = {};

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = params.page;
    payload["limitBy"]["per_page"] = params.per_page;

    payload["filterBy"] = [];

    if (params["filters"]["email"] && params["filters"]["email"] !== "") {
      payload["filterBy"].push({
        attribute: "email",
        op: "like",
        value: params["filters"]["email"]?.toLowerCase(),
      });
    }

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAdminByUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = "/loco/resource/admin-admins/_read";

    let payload: any = {};
    payload["apiConfig"] = {};

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = 1;
    payload["limitBy"]["per_page"] = 1;

    payload["filterBy"] = [];

    payload["filterBy"].push({
      attribute: "uuid",
      op: "eq",
      value: uuid,
    });

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAdminByEmail(email: any) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-admins/_read";

    let payload: any = {};
    payload["apiConfig"] = {};

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = 1;
    payload["limitBy"]["per_page"] = 1;

    payload["filterBy"] = [];

    payload["filterBy"].push({
      attribute: "email",
      op: "eq",
      value: email?.toLowerCase(),
    });

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function createAdminAdmin(payload: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = "/loco/resource/admin-admins/_create";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function updateAdminByUuid(payload: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = "/loco/resource/admin-admins/_patch";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function deleteAdminByUuid(payload: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = "/loco/resource/admin-admins/_delete";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
